import './sass/main.scss';
import AppRoutes from './AppRoutes';
import { BrowserRouter } from 'react-router-dom';
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PendingPaymentRecovery from './components/PendingPaymentRecovery';

function App() {
  const theme = createTheme({
    typography: {
      fontFamily: 'Roboto Condensed, sans-serif',
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <BrowserRouter>
          <PendingPaymentRecovery />
          <AppRoutes />
        </BrowserRouter>
        <ToastContainer
          position="bottom-center"
          autoClose={3000}
          theme="colored"
          hideProgressBar
          pauseOnHover={false}
          limit={3}
        />
      </div>
    </ThemeProvider>
  );
}

export default App;
